import { NegotiationType } from 'api'
import { CheckboxProps } from 'view/components/inputs'
import { NegotiationCheckboxRendererProps } from './NegotiationCheckboxRenderer'

interface NegotiationActionRendererDescendentComponentProps {
  checkboxProps: Partial<CheckboxProps>
}

type GetDescendantComponentProps = (parentProps: NegotiationCheckboxRendererProps) => NegotiationActionRendererDescendentComponentProps
export const getDescendantComponentProps: GetDescendantComponentProps = ({ data: negotiationDetail }: NegotiationCheckboxRendererProps) => {
  if (negotiationDetail?.negotiation.negotiationType === NegotiationType.CONTINGENT_ITEM) {
    return {
      checkboxProps: {
        disabled: true
      }
    }
  }

  return {
    checkboxProps: {}
  }
}
